import styled from "styled-components";
import {
  Dialog,
  Type,
  Flex,
  Button,
  InputGroup,
} from "@ebscois/react-component-library";

export const StyledDialogContainer = styled(Dialog)`
  color: ${({ theme }) => theme.colors.gray800};
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    font-size: ${({ theme }) => theme.font.size.lg};
  }
`;

export const StyledDialogHeading = styled(Type)`
  margin: ${({ theme }) => theme.space.lg} ${({ theme }) => theme.space.sm} 0;
  color: ${({ theme }) => theme.colors.gray800};
  font-family: ${({ theme }) => theme.font.family.secondary};
  padding-bottom: ${({ theme }) => theme.space.xs};
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    margin: ${({ theme }) => theme.space.xl} ${({ theme }) => theme.space.md} 0;
    padding-bottom: ${({ theme }) => theme.space.sm};
  }
`;

export const StyledDialogMessage = styled(Type)`
  margin: ${({ theme }) => theme.space.sm} ${({ theme }) => theme.space.sm} 0;
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    font-size: ${({ theme }) => theme.font.size.md};
    font-style: italic;
    margin: ${({ theme }) => theme.space.md} ${({ theme }) => theme.space.md} 0;
  }
`;

export const StyledRadioGroupWrapper = styled.fieldset`
  margin: ${({ theme }) => theme.space.sm} ${({ theme }) => theme.space.sm} 0;
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    margin: ${({ theme }) => theme.space.md} ${({ theme }) => theme.space.md} 0;
  }
`;

export const StyledInputGroup = styled(InputGroup)`
  margin-top: ${({ theme }) => theme.space.md};
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    margin-top: ${({ theme }) => theme.space.lg};
  }
`;

export const StyledTypeButtonWrapper = styled(Flex)`
  margin: ${({ theme }) => theme.space.lg} 0;
  display: inline-flex;
  justify-content: center;
  width: 100%;
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    margin: ${({ theme }) => theme.space.lg} 0 ${({ theme }) => theme.space.xl};
  }
`;

export const StyledSaveButton = styled(Button)`
  margin-right: ${({ theme }) => theme.space.sm};
  align-items: center; /* for firefox */
`;

export const StyledCancelButton = styled(Button)`
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    display: block;
    color: ${({ theme }) => theme.colors.anchor};
  }
`;
